import { css } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";

export const labelStyle = css`
    ${Fonts.Control.Input};
    padding: 8px 24px;
`;
